module.exports = __webpack_public_path__ + "static/media/SMSSocial.f089c87d.svg";